@if (multiple !== null) {
  <mat-form-field
    appearance="outline"
    subscriptSizing="dynamic"
  >
    @if (arrowPosition !== 'right') {
      <mat-icon
        class="left-arrow-icon"
        style="margin-right: 0.5rem"
        matIconSuffix
        [svgIcon]="EsvgFiles.arrow_down"
      />
    }

    @if (icon) {
      <mat-icon
        style="margin-right: 0.5rem"
        matIconPrefix
        [svgIcon]="icon"
      />
    }

    @if (!hideLabel && label) {
      <mat-label>{{ label }}</mat-label>
    }

    <mat-select
      #selectElement
      class="hide-arrow"
      panelClass="custom-panel"
      [panelClass]="shouldOpenUpwards ? 'mat-select-panel-above' : ''"
      [formControl]="formControlElement"
      [placeholder]="label"
      [multiple]="multiple"
      [value]="formControlElement.value"
      [compareWith]="compareWith"
      (closed)="onSelectionChange(formControlElement.value)"
      (opened)="focusSearchInput()"
    >
      @if (searchForm) {
        <kpi4me-search-input
          [control]="searchForm"
          (ngModelChange)="onSearchChange($event)"
          class="search-form"
        />
      }

      @if (emptyOptionAdded && !multiple) {
        <mat-option [value]="''">
          <div style="display:flex; justify-content: space-between">
            <span
              class="display-name"
              [matTooltip]="''"
            ></span>
          </div>
        </mat-option>
      }

      @if (multiple) {
        <ng-container style="width: 100%">
          <mat-checkbox
            class="select-all-checkbox"
            color="primary"
            [checked]="selectAllChecked"
            (change)="onSelectAll($event)"
          >
            Alle auswählen
          </mat-checkbox>
        </ng-container>
      }

      @for (o of filteredOptions | async; track o.value) {
        <mat-option
          [value]="o.value"
          [style.display]="o._matchesSearch === false ? 'none' : null"
        >
          <div style="display:flex; justify-content: space-between">
            <span class="display-name">{{ o.name }}</span>

            <span class="icon-wrapper">
            @if (copyEnabled) {
              <mat-icon
                (click)="copy($event, o);"
                class="blue-icon smaller-icon"
                svgIcon="{{EsvgFiles.copy}}"
                [matTooltip]="copyTooltip"
              />
            }

              @if (deleteAlwaysEnabled || (deleteEnabled && isOptionUnused(o))) {
                <mat-icon
                  (click)="delete($event, o)"
                  class="red-icon smaller-icon"
                  svgIcon="{{EsvgFiles.delete}}"
                  [matTooltip]="deleteTooltip"
                />
              }

              @if (editEnabled) {
                <mat-icon
                  (click)="edit($event, o)"
                  class="blue-icon smaller-icon"
                  svgIcon="{{EsvgFiles.edit}}"
                  [matTooltip]="editTooltip"
                />
              }

          </span>
          </div>
        </mat-option>
      }


      <mat-option [value]="''" style="display: none"/>

      @if (createNewEnabled) {
        <kpi4me-create-new-entity
          class="create-new-option"
          [label]="newButtonLabel"
          (click)="createNewOption(label)"
        />
      }

      @if (clearEnabled) {
        <kpi4me-clear-entity
          class="create-new-option"
          (click)="clearSelection()"
        />
      }

      @if (confirmButton) {
        <div class="confirm-button-wrapper">
          <button
            class="confirm-button mat-mdc-raised-button mat-primary mdc-button mat-mdc-button-base"
            (click)="onConfirm()"
          >
            Bestätigen
          </button>
        </div>
      }
    </mat-select>

    @if (arrowPosition === 'right') {
      <mat-icon
        class="left-arrow-icon"
        matSuffix
        [svgIcon]="EsvgFiles.arrow_down"
      />
    }

    <mat-error>
      {{ this.getErrorMessage() }}
    </mat-error>
  </mat-form-field>
}
